export default __webpack_public_path__ + "static/media/App_Store_Badge.8c4986ee.svg";